<div class="card" *ngIf="loading">
    <div class="card-body">
        <app-preloader ></app-preloader>
    </div>
</div>

<div class="card" *ngIf="!loading">
    <div class="card-body flex flex-col gap-6">
        <h6 class="text-lg text-gray-500 font-semibold"> {{manageCategoryData.action | titlecase }} Category</h6>
        <div class="card">
            <div class="card-body">
                <form (ngSubmit)="manageCategoryForm.form.valid && onSubmit()" #manageCategoryForm="ngForm">
                    <div class="mb-6" [ngClass]="{ 'border-error': manageCategoryForm.submitted && !label.valid }">
                        <label for="input-label-with-helper-text" class="block text-sm mb-2 text-gray-700">
                            Label
                        </label>
                        <input type="text" id="input-label-with-helper-text"
                            class="py-3 px-4 text-gray-100 block w-full border-gray-100 rounded-sm text-sm focus:border-blue-600 focus:ring-0 "
                            [(ngModel)]="categoryModel.label"
                            autocomplete="off"
                            name="label"
                            #label="ngModel"
                            required
                            aria-describedby="hs-input-helper-text">
                        <p *ngIf="manageCategoryForm.submitted && !label.valid" class="text-error text-sm opacity-75 mt-2">
                            Label is required
                        </p>
                    </div>

                    <div class="mb-6" [ngClass]="{ 'border-error': manageCategoryForm.submitted && !order.valid }">
                        <label for="input-label-with-helper-text" class="block text-sm mb-2 text-gray-700">
                            Order
                        </label>
                        <input type="text" id="input-label-with-helper-text"
                            class="py-3 px-4 text-gray-500 block w-full border-gray-200 rounded-sm text-sm focus:border-blue-600 focus:ring-0 "
                            [(ngModel)]="categoryModel.order"
                            autocomplete="off"
                            name="order"
                            #order="ngModel"
                            required
                            aria-describedby="hs-input-helper-text">
                        <p *ngIf="manageCategoryForm.submitted && !order.valid" class="text-error text-sm opacity-75 mt-2">
                            Order is required
                        </p>
                    </div>

                    <div class="mb-6" [ngClass]="{ 'border-error': manageCategoryForm.submitted && !value.valid }">
                        <label for="input-label-with-helper-text" class="block text-sm mb-2 text-gray-700">
                            Value
                        </label>
                        <input type="text" id="input-label-with-helper-text"
                            class="py-3 px-4 text-gray-500 block w-full border-gray-200 rounded-sm text-sm focus:border-blue-600 focus:ring-0 "
                            [(ngModel)]="categoryModel.value"
                            autocomplete="off"
                            name="value"
                            #value="ngModel"
                            required
                            aria-describedby="hs-input-helper-text">
                        <p *ngIf="manageCategoryForm.submitted && !order.valid" class="text-error text-sm opacity-75 mt-2">
                            Value is required
                        </p>
                    </div>

                    <div class="mb-6">
                        <label for="input-label-with-helper-text" class="block text-sm mb-2 text-gray-700">
                            Description
                        </label>
                        <textarea id="input-label-with-helper-text"
                            class="py-3 px-4 text-gray-500 block w-full border-gray-200 rounded-sm text-sm focus:border-blue-600 focus:ring-0 "
                            placeholder=""
                            [(ngModel)]="categoryModel.description"
                            autocomplete="off"
                            name="description"
                            #description="ngModel"
                            aria-describedby="hs-input-helper-text"></textarea>
                    </div>
                    <button type="submit" class="btn text-base py-2.5 text-white font-medium w-fit hover:bg-blue-700"> {{
                        (manageCategoryData.action == 'add') ? 'Save' : 'Update' }} </button>
                    <button type="button"
                        class="py-2.5 px-4 inline-flex items-center gap-x-2 font-semibold rounded-2xl border text-gray border-gray-200 hover:border-gray-200 hover:text-white hover:bg-gray-500"
                        (click)="triggerCategoryResponse('cancel')">
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>